import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "../../agent/Styles/darktheme.css";
import { setAudioSettings } from "../../actions/common";
import getV2AxiosInstance from "../../utils/v2Axios.js";
import {
  Modal,
  Button,
  FormGroup,
  ControlLabel,
  FormControl,
} from "react-bootstrap";
import classnames from "classnames";
import "../../agent/Styles/blacktheme.css";
import "../../agent/Styles/highContrast.css";

class AudioSettingsModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: this.props.showModal,
      audioOutputs: [],
      selectedRingDevice: '',
      selectedVoiceDevice: '',
      prevAudioOutputSelection: {},
    };
  }


  componentDidUpdate(prevProps) {
    if (prevProps.showModal !== this.props.showModal) {
      this.setState({ showModal: this.props.showModal });
      if (this.props.showModal) {
        this.listAudioDevices();
      }
    }


    if (prevProps.audioOutputSelection !== this.props.audioOutputSelection) {
      this.setState({
        selectedRingDevice: this.props.audioOutputSelection.output_ring_device ,
        selectedVoiceDevice: this.props.audioOutputSelection.output_voice_device,
      });
    }
  }
  
  componentDidMount() {
        this.listAudioDevices();
  }
  close = () => {
    this.props.handleClose(false);
  };

  listAudioDevices = () => {
    const { translations, selectedLanguage } = this.props;
      
    navigator.mediaDevices
      .enumerateDevices()
      .then((devices) => {
        let audioOutputs = devices.filter(
          (device) =>
            device.kind === "audiooutput" &&
            device.deviceId !== "default" &&
            device.deviceId !== "communications"
        );
        audioOutputs.unshift({"deviceId": "", "kind": "audiooutput", "label": `${translations.default[selectedLanguage]}`, "groupId": ""});
        this.setState({ audioOutputs });
      })
      .catch((err) => console.error("Error listing audio devices:", err));
  };

  handleOk = () => {
    //event.persist();
    let { selectedRingDevice, selectedVoiceDevice } = this.state;
    let selectedDevices = {
      output_ring_device: selectedRingDevice,
      output_voice_device: selectedVoiceDevice,
    };


    const username = localStorage.getItem("username");
    const agent_id = localStorage.getItem("agent_id");
    const client_id = localStorage.getItem("clientId");
    this.props.setAudioSettings(selectedDevices);

    getV2AxiosInstance()
      .patch(`/api/en/invoxapi/userproperties/${username}`, {
        data: {
          apps: {
            webphone: {
              audio_settings: {
                output_ring_device: selectedDevices.output_ring_device,
                output_voice_device: selectedDevices.output_voice_device,
              },
            },
          },
        },
      })
      .then((res) => {
        if (res.data.result) {
          let deviceSelection = JSON.stringify(selectedDevices);
          // let deviceSelection = selectedDevices;
          // console.log('SAVING: ', deviceSelection);
          // console.log('MESAGE: ', `{"tag": "audio_settings_change", "data": "${deviceSelection}"}`);
          window.mq.send(
              `/exchange/signal.${client_id}/user.${agent_id}`, 
              {},
              `{"tag": "audio_settings_change", "data": ${deviceSelection}}`);
        }
      });

    this.props.handleClose(true);
  };

  handleRingDeviceChange = (event) => {
    let selectedDeviceId = event.target.value;
    this.setState({ selectedRingDevice: selectedDeviceId });
  };

  handleVoiceDeviceChange = (event) => {
    let selectedDeviceId = event.target.value;
    this.setState({ selectedVoiceDevice: selectedDeviceId });
  };

  render() {
    const { showModal, audioOutputSelection, translations, selectedLanguage } = this.props;
    const { audioOutputs, selectedRingDevice, selectedVoiceDevice  }= this.state;
    const modalKey = `${audioOutputSelection.output_ring_device}-${audioOutputSelection.output_voice_device}`;

    return (
      <Modal show={showModal} key={modalKey} onHide={() => this.close()} className="modal">
        <Modal.Header
          className={`modal-content${this.props.theme} modal-header${this.props.theme}`}
          closeButton
        >
          <Modal.Title>{translations.selectAudio[selectedLanguage]}</Modal.Title>
        </Modal.Header>
        <Modal.Body className={`modal-content${this.props.theme}`}>
          <form>
            <FormGroup controlId="ringOutputSelect">
              <ControlLabel>{translations.ringOutput[selectedLanguage]}</ControlLabel>
              <FormControl
                componentClass="select"
                value={ selectedRingDevice || ''}
                onChange={this.handleRingDeviceChange}
                className={classnames(
                  `list-group-item list-group-item${this.props.theme}`
                )}
                style={{ height: "auto" }}
              >
                {audioOutputs.map((device) => (
                  <option key={device.deviceId} value={device.deviceId}>
                    {device.label || `Microphone ${device.deviceId}`}
                  </option>
                ))}
              </FormControl>
            </FormGroup>
            <FormGroup
              controlId="voiceOutputSelect"
              style={{ marginTop: "16px" }}
            >
              <ControlLabel>{translations.voiceOutput[selectedLanguage]}</ControlLabel>
              <FormControl
                componentClass="select"
                value={ selectedVoiceDevice || 'salchipapa'}
                onChange={this.handleVoiceDeviceChange}
                className={classnames(
                  `list-group-item list-group-item${this.props.theme}`
                )}
                style={{ height: "auto" }}
              >
                {audioOutputs.map((device) => (
                  <option key={device.deviceId} value={device.deviceId}>
                    {device.label || `Speaker ${device.deviceId}`}
                  </option>
                ))}
              </FormControl>
            </FormGroup>
          </form>
        </Modal.Body>
        <Modal.Footer
          className={`modal-content${this.props.theme}`}
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Button
            className={`btn-link btn-link${this.props.theme} modal-action${this.props.theme}`}
            onClick={() => this.close()}
            style={{ flex: "1", margin: "0" }}
          >
            {translations.cancel[selectedLanguage]}
          </Button>
          <Button
            className={`btn-link btn-link${this.props.theme} modal-action${this.props.theme}`}
            onClick={this.handleOk}
            style={{ flex: "1", margin: "0" }}
          >
            {translations.save[selectedLanguage]}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    
    translations: state.languages.translations,
    selectedLanguage: state.languages.selectedLanguage,
    theme: state.common.theme,
    audioOutputSelection: state.common.audioOutputSelection,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setAudioSettings,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(AudioSettingsModal);



// WEBPACK FOOTER //
// ./src/agent/modals/AudioSettingsModal.js